<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="h-30"></div>
    <div class="facility-heading">View BounceBack® Invitation</div>
    <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">Invitation Details</span>
          <span class="reviewstatus-{{bbInvitation.status.toLowerCase()}}">{{bbInvitation.statusDescription.toUpperCase()}}</span>
        </div>
        <div class="mb-10"></div>
        <div class="review-form-fileds">
          <span class="label" >Email</span>
          <span class="answers">{{bbInvitation.email}}</span>
        </div>


        <div class="review-form-fileds">
          <span class="label">Case ID Number</span>
          <span class="answers">{{bbInvitation.caseIdNumber}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Program</span>
          <span class="answers">{{bbInvitation.program}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Coach</span>
          <span class="answers">{{bbInvitation.coach}}</span>

        </div>

        @if (bbInvitation.isBranchVisible) {
          <div class="review-form-fileds">
            <span class="label">Branch</span>
            <span class="answers">{{bbInvitation.branch || '—'}}</span>
          </div>
        }


        <div class="review-form-fileds">
          <span class="label">Program Start Date</span>
          <span class="answers">{{bbInvitation.programStartDate}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Invite Expiry Date</span>
          <span class="answers">{{bbInvitation.inviteExpiryDate}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Invite Link</span>
          <span class="answers">{{bbInvitation.inviteLink}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Date Accessed</span>
          <span class="answers">{{bbInvitation.dateAccessed}}</span>

        </div>
        <div class="h-30"></div>

        <div class="form-buttons">
          <button class="submit-form-button" (click)="navigate()" [hidden]="!bbInvitation.isEditEnabled && !showEditButton">Edit</button>
          @if (canResend) {
            <button type="button" class="submit-form-button" (click)="openResend()">Resend Invitation</button>
          }
        </div>

        @if (resendMessage && !showResendForm && !resendFailed) {
          <div class="resend-success" role="status">{{resendMessage}}</div>
        }

      </div>
    </form>
    <app-audit-logs [auditLogs]="auditLogs"></app-audit-logs>
  </div>

</div>
@if (showResendForm) {
  <div class="resend-backdrop" (click)="closeResend()">
    <div class="resend-modal" role="dialog" aria-modal="true" aria-labelledby="resendTitle"
         (click)="$event.stopPropagation()" (keydown.escape)="closeResend()">
      <h2 id="resendTitle">Resend Invitation</h2>
      <p class="resend-sub">
        This invitation has expired. Choose a new expiry date and a new invitation email will be sent to
        <strong>{{bbInvitation.email}}</strong>.
      </p>
      <label for="newExpiryDate">New expiry date</label>
      <input id="newExpiryDate" type="date" name="newExpiryDate" [(ngModel)]="newExpiryDate"
             [min]="minExpiryDate" (click)="$any($event.target).showPicker?.()" autofocus />
      @if (resendFailed && resendMessage) {
        <p class="resend-error" role="alert">{{resendMessage}}</p>
      }
      <div class="resend-actions">
        <button type="button" class="resend-btn secondary" (click)="closeResend()">Cancel</button>
        <button type="button" class="resend-btn primary" (click)="resend()" [disabled]="isResending || !newExpiryDate">
          {{isResending ? 'Sending...' : 'Resend'}}
        </button>
      </div>
    </div>
  </div>
}
<app-footer></app-footer>
